import React, { Component } from "react";
import { getDataSources } from "../../../services/dataSourceService";
import CustomLoader from "../../common/Loader";
import {
  getDT,
  toFindColumns,
  saveDT,
  getSPV,
  findParameters,
  getFormDataElements
} from "../../../services/formService";
import * as Icon from "react-feather";
import { toast, ToastContainer } from 'react-toastify';
import { toaster } from '../../../config';
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import { ResultSource } from "../../../constants/ResultSource";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { getProjectForms } from "../../../services/projectService";
import { logActivity } from '../../../services/utilService';
import { SketchPicker } from 'react-color';
import { colors } from "@material-ui/core";
import { WidgetTypes } from "../../../constants/QuestionTypes";

class WInfo extends Component {
  DataSources = [];
  Forms = [];
  RowActions = [];
  ResultSources = [];
  StoredProcedures = [];
  Views = [];
  DEs = [];

  state = {
    Project_ID: parseInt(this.props.Project_ID),
    Form_ID: parseInt(this.props.Form_ID),
    Widget_ID: this.props.Widget.Widget_ID,
    Widget_Type_ID: this.props.Widget_Type_ID,
    DT_ID: 0,
    DE_ID: 0,
    DataSource_ID: 0,
    ResultSource_ID: 0,
    ResultSource_Content: "",
    Action_ID: 0,
      Action_Form_ID: null,
      Display_Name: "",
      Columns: [],
      Parameters: [],
      WithinRow: false,
      selected_column: "",
      can_save: true,
      open_options: "",
      colorSwitch: this.props.Widget_Color && this.props.Widget_Color!=='#0061F2' ? true : false,
      bucketColor: this.props.Widget_Color ? this.props.Widget_Color : '#0061F2',
      bucketDisplayClass: '',
      Widget_Color: this.props.Widget_Color ? this.props.Widget_Color : '#0061F2',
      //Params: [],
      loading: true,
    };

  constructor(props) {
    super(props);
    this.handleSave = this.handleSave.bind(this);
    this.handleRemove = this.handleRemove.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleSPVChange = this.handleSPVChange.bind(this);
    this.handleCheck = this.handleCheck.bind(this);
    this.clearStatus = this.clearStatus.bind(this);
    this.handleColumn = this.handleColumn.bind(this);
    this.updateDEStateObj = this.updateDEStateObj.bind(this);
    this.wrapperRef = React.createRef();
    this.handleClickOutside = this.handleClickOutside.bind(this);
  }

  clearStatus = () => {
    this.setState({ DataSource_ID: 0 });
    this.setState({ ResultSource_Content: "" });
    this.setState({ Columns: [] });
    this.setState({ Parameters: [] });
  };

  getOptions = async (
    DataSource_ID = this.state.DataSource_ID,
    ResultSource_ID = this.state.ResultSource_ID
  ) => {
    const { data } = await getSPV(ResultSource_ID, this.getConn(DataSource_ID));
    if (ResultSource_ID === ResultSource.SP) {
      this.StoredProcedures = data;
    } else if (ResultSource_ID === ResultSource.View) {
      this.Views = data;
    }
  };

  async loadDT() {
    const { data } = await getDT(this.state.Widget_ID);

    let { data: Forms } = await getProjectForms(this.state.Project_ID);
    this.Forms = Forms.filter((form) => form.Form_ID !== this.props.Form_ID);

    this.RowActions = JSON.parse(data.rowActions);
    this.ResultSources = [
      { ResultSource_ID: 0, ResultSource_Type_Name: "Static Text" },
      ...JSON.parse(data.resultSources),
      { ResultSource_ID: JSON.parse(data.resultSources).length + 1, ResultSource_Type_Name: "Shared Data Element" }
    ];

    const DT = JSON.parse(data.DT)[0];
    if (DT) {
      this.setState({...this.state,
        DT_ID: parseInt(DT.DT_ID),
        DataSource_ID: DT.DataSource_ID,
        ResultSource_ID: DT.ResultSource_ID,
        ResultSource_Content: DT.ResultSource_Content,
        open_options: DT.ResultSource_Content,
        Action_ID: DT.Action_ID,
        Action_Form_ID: DT.Action_Form_ID,
        Display_Name: DT.Display_Name,
        Columns: JSON.parse(data.Columns),
        Parameters: JSON.parse(data.Parameters),
        WithinRow: DT.WithinRow,
      });

      let columns = JSON.parse(data.Columns);
      if (columns.length > 0) {
        let selected_column = columns.find((c) => c.Visible) ? columns.find((c) => c.Visible).Column_Name : 0;
        this.setState({ selected_column });
      }

      if (DT.ResultSource_ID > 0 && DT.ResultSource_ID !== ResultSource.DataElement) {
        this.getOptions(DT.DataSource_ID, DT.ResultSource_ID);
      }
    }
    return Promise.resolve('Success');
  }

  async componentDidMount() {
    const { data: DS } = await getDataSources();
    this.DataSources = DS;
    this.loadDT().
      then(this.getFormDataElements()).
      then(
        () => {
          document.addEventListener("mousedown", this.handleClickOutside);
          if (this.state.ResultSource_ID === ResultSource.DataElement) {
            let DE_ID = Array.prototype.findIndex.call(this.DEs, (x) => x.ResultSource_Content === this.state.ResultSource_Content);
            this.setState({ DE_ID });
            this.updateDEStateObj((DE_ID === -1) ? 0 : DE_ID);
            this.findColumns();
          }
          this.setState({ loading: false });
        }
      )
    
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside);
  }

  handleClickOutside(event) {
    if (this.wrapperRef && this.wrapperRef.current && !this.wrapperRef.current.contains(event.target) && !(event.target.id).includes('colorSwitchLabel') ) {
      this.setState({'bucketDisplayClass': 'd-none'})
    }
  }

  handleColorSwitch = () => {
    this.setState({colorSwitch:!this.state.colorSwitch})
    this.setState({'bucketDisplayClass': ''})
  }

  handleColorChange = (color) => {
    this.setState({ bucketColor: color.hex });
    toaster('success', `Bucket Color selected: ${color.hex}`)
  }

  handleChange = ({ target }) => {
    let name = target.name;
    let value = target.value;

    if (name.includes("ID")) {
      name = name.split(":").pop();
      value = parseInt(value);
    }
    this.setState({ ...this.state, [name]: value });

    if (name === "ResultSource_ID") {
      this.clearStatus();
      (value === ResultSource.DataElement) && this.getFormDataElements() && this.updateDEStateObj(this.state.DE_ID);
    } else if (name === "DataSource_ID") {
      this.getOptions(value);
      this.setState({ can_save: false });
    }
  };

  getConn(DataSource_ID = this.state.DataSource_ID) {
    const source = this.DataSources.find((source) => {
      return source.DataSource_ID === DataSource_ID;
    });
    return source.Connection_String;
  }

  async getFormDataElements(){
      const { data } = await getFormDataElements(this.state.Form_ID);
      this.DEs = JSON.parse(data.dataElements);
  }

  handleSPVChange = async (e, value) => {
    this.setState({ ResultSource_Content: value });

    if (this.state.ResultSource_ID === ResultSource.SP) {
      const { data } = await findParameters(value, this.getConn());
      if (typeof data === "object") {
        const Parameters = data.map((par, idx) => {
          par.Parameter_ID = idx;
          par.Default_Value = "";
          if ((par.Name).toLowerCase().includes('institution')) {
            let institutionElId = document.getElementById('userInst').value;            par.Default_Value = institutionElId
          } 
          return par;
        });
        this.setState({ Parameters });
      }
    }
  };

  findColumns = async () => {
    const { data } = await toFindColumns(
      this.state.ResultSource_ID,
      this.state.ResultSource_Content,
      this.getConn(),
      this.state.Parameters,
      true
    );

    if (typeof data === "string") {
      toaster('error', data);
      this.setState({ Columns: [] });
    } else {
      this.setState({ can_save: true });
      const Columns = data.map((col) => {
        return {
          Column_ID: 0,
          Column_Name: col,
          Column_Display_Name: col ? col : "(no column name)",
          isPrimary: false,
          Visible: false,
        };
      });
      this.setState({ Columns });
    }
  };

  handleSave = async () => {
    const { data } = await saveDT(this.state);
    if (data.includes("Error")) {
      toaster('error', data);
      logActivity('/formBuilder', (this.state.Widget_Type_ID === WidgetTypes.Info) ? 'WIDGET_INFO_SAVE_FAILED' : 'WIDGET_BUTTON_FAILED');
    } else {
      toaster('success', 'Widget saved.');
      logActivity('/formBuilder', (this.state.Widget_Type_ID === WidgetTypes.Info) ? 'WIDGET_INFO_SAVE_SUCCESS' : 'WIDGET_BUTTON_SAVE_SUCCESS');
      const DT_ID = parseInt(data.split(":").pop());
      this.setState({ DT_ID });
      this.loadDT();
    }
  };

  handleRemove = () => {
    this.props.onRemove(this.state.Widget_ID);
  };

  handldParChange = (text, index) => {
    const Parameters = [...this.state.Parameters];
    Parameters[index]["Default_Value"] = text;
    this.setState({ Parameters });
  };

  handleCheck = () => {
    this.setState({ WithinRow: !this.state.WithinRow });
  };

  handleColumn = ({ target }) => {
    let column = target.value;

    let Columns = [...this.state.Columns];
    Columns = Columns.map((col) => {
      col.Visible = col.Column_Name === column ? true : false;
      //col.isPrimary = col.Column_Name === column ? true : false;
      return col;
    });
    this.setState({ selected_column: column });
    this.setState({ Columns: Columns });
  };

  updateDEStateObj = (targetID) => {
    let idx = parseInt(targetID), selectedDEObj = this.DEs[idx];
    targetID !== -1 &&
      this.setState({
        DataSource_ID: selectedDEObj ? selectedDEObj.DataSource_ID : this.state.DataSource_ID,
        ResultSource_ID: ResultSource.DataElement,
        ResultSource_Content: selectedDEObj ? selectedDEObj.ResultSource_Content : '',
        Parameters: selectedDEObj ? JSON.parse(selectedDEObj.jsonParameters) : [],
        DE_ID: idx,
      });
  };

  // handleAddParam() {
  //   const Params = [...this.state.Params, { 'Param_ID': this.state.Params.length, 'Param_Key': '', 'Param_Value': '' }];
  //   this.setState({ Params });
  //   console.log('Params:: ', Params);
  // };

  // handleRemoveParam(idx) {
  //   let Params = this.state.Params.filter(function (param, index) {
  //     return index !== idx;
  //   });
  //   Params.map((param, idx) => {
  //     param['Param_ID'] = idx
  //   })
  //   this.setState({ Params });
  // };

  // handleParamChange = (input, idx) => {
  //   let Params = this.state.Params
  //   Params.map((param) => {
  //     if (param['Param_ID'] === idx) {
  //       param[input.name] = input.value
  //     }
  //   })
  //   this.setState({ Params })
  // };

  render() {
    if (this.state.loading) {
      return <CustomLoader loading={this.state.loading} />;
    }

    const {
      DataSource_ID,
      Action_ID,
      Action_Form_ID,
      ResultSource_ID,
      DE_ID,
      Display_Name,
      ResultSource_Content,
      Widget_ID,
      Widget_Type_ID,
      open_options,
      Parameters,
      WithinRow,
      colorSwitch,
      bucketColor,
      Columns,
    } = this.state;

    return (
      <React.Fragment>
        <div className="form-group" key={Widget_ID}>
          <label htmlFor={"Display_Name" + Widget_ID}>Title</label>
          <input
            className="form-control"
            id={"Display_Name" + Widget_ID}
            type="text"
            name="Display_Name"
            value={Display_Name}
            onChange={this.handleChange}
          />
        </div>

        <div className='row'>
          <div className="col-md-5 form-group">
            <div className="custom-control custom-switch mt-n2">
              <input
                type="checkbox"
                name='Include_RowWidget'
                id={'rowSwitch' + Widget_ID}
                className="custom-control-input"
                checked={WithinRow}
                value={WithinRow}
                onChange={this.handleCheck}
              />
              <label htmlFor={'rowSwitch' + Widget_ID} className="custom-control-label">
                Include in row widget
              </label>
            </div>
          </div>
          {/* Bucket Color */}
          { Widget_Type_ID === WidgetTypes.Info && (
          <div className="form-group">
            <div className="custom-control custom-switch mt-n2">
              <input
                type="checkbox"
                name='Pick_BucketColor'
                id={'colorSwitch' + Widget_ID}
                className="custom-control-input"
                checked={colorSwitch}
                value={colorSwitch}
                onChange={this.handleColorSwitch}
              />
              <label id={'colorSwitchLabel' + Widget_ID} name='colorSwitch' htmlFor={'colorSwitch' + Widget_ID} className="custom-control-label">
                Change Bucket Color
              </label>
            </div>
          <div ref={this.wrapperRef} className={`bucketColor ${this.state.bucketDisplayClass}`} id={'bucketColor' + Widget_ID}>
            {colorSwitch && (
              <SketchPicker color={bucketColor} onChangeComplete={this.handleColorChange} />
            )}
          </div>
          </div>
          )}
        </div>
        <div className="form-group">
          <label htmlFor="">{(Widget_Type_ID === WidgetTypes.Info) ? 'Info Source' : 'Button Source'}</label>
          <div className="form-check ml-n3">
            {this.ResultSources.map((source) => {
              return (
                <div
                  className="form-check form-check-inline"
                  key={Widget_ID + source.ResultSource_Type_Name}
                >
                  <input
                    type="radio"
                    className="form-check-input"
                    name={Widget_ID + ":ResultSource_ID"}
                    value={source.ResultSource_ID}
                    checked={source.ResultSource_ID === ResultSource_ID}
                    onChange={this.handleChange}
                  />
                  <label
                    htmlFor={Widget_ID + source.ResultSource_Type_Name}
                    className="form-check-label"
                  >
                    {source.ResultSource_Type_Name}
                  </label>
                </div>
              );
            })}
          </div>
        </div>

        {ResultSource_ID === 0 && (
          <div className="form-group">
            <label htmlFor="">Content</label>
            <input
              type="text"
              className="form-control"
              value={ResultSource_Content}
              name="ResultSource_Content"
              disabled={ResultSource_ID !== 0}
              onChange={this.handleChange}
            />
          </div>
        )}

        {Widget_Type_ID !== WidgetTypes.Randomize &&
          <div className="form-row" key={Widget_ID + "clickEvent"}>
            <div className="form-group col-md-4">
              <label htmlFor={"row_action" + Widget_ID}>Click Event Action</label>
              <select
                id={"row_action" + Widget_ID}
                name={Widget_ID + ":Action_ID"}
                value={Action_ID}
                className="form-control"
                onChange={this.handleChange}
              >
                <option value="0">Select</option>
                {this.RowActions.map((action) => {
                  return (
                    <option key={action.Action_ID} value={action.Action_ID}>
                      {action.Action_Name}
                    </option>
                  );
                })}
              </select>
            </div>
            <div className="form-group col-md-8">
              <label htmlFor={"action_form" + this.state.Widget_ID}>Form</label>
              <select
                id={"action_form" + this.state.Widget_ID}
                className="form-control"
                name={this.state.Widget_ID + ":Action_Form_ID"}
                value={this.state.Action_Form_ID}
                onChange={this.handleChange}
              >
                <option value="-1">Select</option>
                <option value="0">On user selection</option>
                {this.Forms.map((form) => {
                  return (
                    <option key={form.Form_ID} value={form.Form_ID}>
                      {form.Form_Name}
                    </option>
                  );
                })}
              </select>
            </div>
          </div>
        }
        {ResultSource_ID > 0 && (ResultSource_ID !== ResultSource.DataElement) && (
          <React.Fragment>
            <div className="form-group">
              <label htmlFor={"DataSource" + Widget_ID}>Data Source</label>
              <select
                id={"DataSource" + Widget_ID}
                className="form-control"
                value={DataSource_ID}
                name="DataSource_ID"
                onChange={this.handleChange}
              >
                <option value="0" key={Widget_ID + "DSDefault"}>
                  Select
                </option>
                {this.DataSources.map((source) => (
                  <option
                    key={Widget_ID + "DataSource" + source.DataSource_ID}
                    value={source.DataSource_ID}
                  >
                    {source.Description}
                  </option>
                ))}
              </select>
            </div>

            {DataSource_ID !== 0 && (
              <React.Fragment>
                <div className="form-group">
                  {ResultSource_ID === ResultSource.Query && (
                    <div>
                      <TextField
                        id={Widget_ID + "resultSourceContent"}
                        label="Enter Query"
                        variant="outlined"
                        fullWidth
                        margin="dense"
                        name="ResultSource_Content"
                        value={ResultSource_Content}
                        onChange={this.handleChange}
                      />
                    </div>
                  )}

                  {(ResultSource_ID === ResultSource.SP ||
                    ResultSource_ID === ResultSource.View) && (
                    <div>
                      <Autocomplete
                        id={Widget_ID + "resultSourceContent"}
                        options={
                          open_options
                            ? ResultSource_ID === ResultSource.SP
                              ? this.StoredProcedures
                              : this.Views
                            : []
                        }
                        getOptionLabel={(option) => option}
                        fullWidth
                        size="small"
                        value={ResultSource_Content}
                        name="ResultSource_Content"
                        onChange={this.handleSPVChange}
                        inputValue={open_options}
                        onInputChange={(e, val) => {
                          this.setState({ open_options: val });
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label={
                              ResultSource_ID === ResultSource.SP
                                ? "Stored Procedure Name"
                                : "View Name"
                            }
                          />
                        )}
                      />
                      {/* Param Key-Value pairs */}
                      {/* <div className='form-group scroll'>
                        <div className='mt-2'>
                          <label>Parameters</label>
                          <button className='btn btn-outline-primary btn-icon btn-sm ml-2' onClick={() => this.handleAddParam()}>
                            <Icon.Plus size={20} />
                          </button>
                        </div>
                        {this.state.Params.map((param, idx) => {
                          return (
                            <div>
                              <input type='text' id={'paramKey-' + param.Param_ID} name='Param_Key' className='ml-2 mt-2' placeholder='@Parameter_Name' onChange={(e) => this.handleParamChange(e.target, idx)}/>
                              <input type='text' id={'paramVal-' + param.Param_ID} name='Param_Value' className='ml-2 mt-2' placeholder='Parameter Value' onChange={(e) => this.handleParamChange(e.target, idx)} />
                              {idx >= 0 && (
                                <button className='btn btn-outline-danger btn-icon btn-sm ml-2 mt-2 mb-2' onClick={() => this.handleRemoveParam(idx)}>
                                  <Icon.Minus size={20} />
                                </button>
                              )}
                            </div>
                          )
                        }
                        )}
                      </div> */}
                    </div>
                  )}

                  {ResultSource_ID === ResultSource.SP &&
                    Parameters.length > 0 &&
                    Parameters.map((par, idx) => (
                      <TextField
                        id={Widget_ID + "." + par.Name}
                        label={par.Name + "(" + par.Type + ")"}
                        placeholder="Default Value"
                        fullWidth
                        value={par.Default_Value}
                        key={Widget_ID + "parameter" + par.Name}
                        onChange={(e) =>
                          this.handldParChange(e.target.value, idx)
                        }
                      />
                    ))}
                </div>

                <div className="form-group">
                  <label htmlFor="">
                    Column to display{" "}
                    <OverlayTrigger
                      placement="top"
                      overlay={<Tooltip>find columns</Tooltip>}
                    >
                      <span
                        className="badge badge-success pointer"
                        onClick={this.findColumns}
                      >
                        <Icon.Search size={16} />
                      </span>
                    </OverlayTrigger>
                  </label>

                  <select
                    className="form-control"
                    onChange={this.handleColumn}
                    name={Widget_ID + "Column"}
                    value={this.state.selected_column}
                  >
                    <option value="0" key={Widget_ID + "col" + "Default"}>
                      - Select -
                    </option>
                    {Columns.map((column) => (
                      <option
                        value={column.Column_Name}
                        key={Widget_ID + "col" + column.Column_Name}
                        // selected={column.Visible}
                      >
                        {column.Column_Display_Name}
                      </option>
                    ))}
                  </select>
                </div>
              </React.Fragment>
            )}
          </React.Fragment>
        )}
        
        {/* Shared Data Element */}
        {ResultSource_ID > 0 && (ResultSource_ID === ResultSource.DataElement) && (
          <React.Fragment key={this.DEs}>
            <div className="form-group">
              <label htmlFor={"DataElement" + Widget_ID}>Data Element</label>
              <select id={"DataElement" + Widget_ID}  name="DE_ID" className="form-control" value={DE_ID} onChange={(e)=>this.updateDEStateObj(e.target.value)}>
                {this.DEs.map((DE, idx) => (
                  <option value={idx}>
                    {DE.Display_Name}
                  </option>
                ))}
              </select>
            </div>

            {/* Column to select for Info Box */}
            <div className="form-group">
                  <label htmlFor="">
                    Column to display{" "}
                    <OverlayTrigger
                      placement="top"
                      overlay={<Tooltip>find columns</Tooltip>}
                    >
                      <span
                        className="badge badge-success pointer"
                        onClick={this.findColumns}
                      >
                        <Icon.Search size={16} />
                      </span>
                    </OverlayTrigger>
                  </label>

                  <select
                    className="form-control"
                    onChange={this.handleColumn}
                    name={Widget_ID + "Column"}
                    value={this.state.selected_column}
                  >
                    <option value="0" key={Widget_ID + "col" + "Default"}>
                      - Select -
                    </option>
                    {Columns.map((column) => (
                      <option
                        value={column.Column_Name}
                        key={Widget_ID + "col" + column.Column_Name}
                        // selected={column.Visible}
                      >
                        {column.Column_Display_Name}
                      </option>
                    ))}
                  </select>
                </div>

          </React.Fragment>
        )
        }

        {/* <hr className="my-4" /> */}
        <div className="d-flex justify-content-end mt-2">
          <button
            className="btn btn-outline-primary mr-2"
            onClick={this.handleSave}
            disabled={!this.state.can_save}
          >
            Save
          </button>
          <button
            className="btn btn-outline-danger"
            onClick={this.handleRemove}
          >
            Delete
          </button>
        </div>
        <ToastContainer/>
      </React.Fragment>
    );
  }
}

export default WInfo;
